import { Component } from "../../core/Component";
import { I18n } from "~/shared/tools/i18n";
import { applyInlineStyles } from "~/shared/tools/applyInlineStyles";
export class SubmitBtn extends Component {
  constructor($root, options) {
    super($root, options);
    this.options = options;
    this.mode = options.mode;
    this.formId = options.formId;
    this.useAgreement = options.useAgreement || 0;
    this.useDesign = options.useDesign;
    this.hideSubmitButton = options.hideSubmitButton;
    this.submitSetting = options.submitSetting || submitSetting;
    this.showCaption = options.showCaption;
    this.captionLink = options.captionLink;
    this.disabledClass = options.disabledClass;
    this.id = `${this.submitSetting.name}_${options.formId}_${options.formIndex}`;
    this.submitBoxId = `${this.submitSetting.name}_${options.formId}_${options.formIndex}_submit-box`;
    this.qformLabelId = `qform-label_${options.formId}_${options.formIndex}`;
    this.qformLabelLinkId = `qform-label-link_${options.formId}_${options.formIndex}`;
    this.languageId = options.languageId;
    this.$i18n = new I18n(["ru", "ru", "en"][options.languageId]);
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.$submitBox = this.$root.$el.querySelector(`#${this.submitBoxId}`);
    this.$btnSubmit = this.$root.$el.querySelector(`#${this.id}`);
    this.$qformLabel = this.$root.$el.querySelector(`#${this.qformLabelId}`);
    this.$qformLabelLink = this.$root.$el.querySelector(`#${this.qformLabelLinkId}`);
    if (this.$btnSubmit) {
      this.listeners.push({
        eventName: "click",
        method: !disable ? "onClickSubmit" : "onClickDisabledSubmit",
        el: this.$btnSubmit
      });
    }
    this.$subscribe("Submit:disabledBtn", this.disabledSubmit.bind(this));
    this.$subscribe("Submit:addDisabledStyleBtn", this.toggleSubmitDisabledStyle.bind(this));
    this.$subscribe("Submit:loading", this.toggleLoading.bind(this));
    this.$emit("Change:field", {});
    super.init();
    this.toggleSubmitDisabledStyle(disable);
    if (this.showCaption) {
      this.startLabelProtectionInterval();
    }
  }
  toHTML() {
    this.$root.html(`
          <div class="qform-field ${this.useAgreement === 0 ? "qform__mb-0" : ""}">
            <div class="qform-field__submit" id="${this.submitBoxId}">
              ${this.hideSubmitButton ? "" : `<div class="submit-box">
                  <input
                    type="submit"
                    class="${this.useDesign ? "qform-field__submit__input" : ""} ${this.submitSetting.class}"
                    name="${this.submitSetting.name}"
                    id="${this.id}"
                    value="${this.submitSetting.text}"
                  >
                </div>`}
              ${this.showCaption ? this.getLabelHTML() : ""}
            </div>
          </div>
        `);
  }
  onClickSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.isTrusted && this.mode) {
      this.$emit("Submit:validForm", {});
    }
  }

  /**
   * Нужно, чтобы подсвечивать плашку с ограничением ☦☦☦☦☦☦☦☦☦☦; Задача: QFOR-9230
   * @param event {Event}
   * */
  onClickDisabledSubmit(event) {
    event.preventDefault();
    const el = event.target.closest("form")?.parentElement.querySelector(".qform-restrictions-wrapper");
    if (el) {
      el.classList.add("--blink");
      setTimeout(() => el.classList.remove("--blink"), 3000);
    }
  }
  disabledSubmit(status) {
    this.$btnSubmit.disabled = status;
  }
  toggleSubmitDisabledStyle(disable) {
    if (!!this.disabledClass) {
      this.$submitBox.classList.toggle("qform-submit-disabled", disable);
    }
  }
  toggleLoading() {
    let loaderShown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.$submitBox.classList[loaderShown === true ? "add" : "remove"]("qform-submit-loading");
  }
  getLabelHTML() {
    const url = new URL(this.captionLink);
    url.searchParams.append("utm_source", window.location.host);
    url.searchParams.append("utm_medium", "form");
    url.searchParams.append("region", new Intl.Locale(navigator.language));
    url.searchParams.append("lang", navigator.language || navigator.userLanguage);
    return `<p class="qform__form-label" id="${this.qformLabelId}">
          <a
            href="${url.href}" 
            id="${this.qformLabelLinkId}" 
            target="_blank" 
            rel="noopener noreferrer" 
            title="Qform.io"
            class="qform__form-label__link"
          >
          ${this.$i18n.t("bottomLabel.createForm")}
          </a>
          <span>
            ${this.$i18n.t("bottomLabel.helpWithQform")}
          </span>     
        </p>`;
  }
  applyForceLabelStyles() {
    applyInlineStyles(this.$qformLabel, {
      opacity: '1',
      display: 'block',
      'font-size': '.71em',
      'text-indent': '0',
      overflow: 'visible',
      height: 'auto',
      width: 'auto',
      scale: '1',
      transform: 'none'
    }, 'important');
    applyInlineStyles(this.$qformLabelLink, {
      opacity: '1',
      display: 'inline',
      'text-indent': '0',
      overflow: 'visible',
      height: 'auto',
      width: 'auto',
      scale: '1',
      transform: 'none'
    }, 'important');
  }
  startLabelProtectionInterval() {
    this.applyForceLabelStyles();
    let interval = setInterval(() => {
      this.$qformLabel.remove();
      this.$submitBox.insertAdjacentHTML("beforeend", this.getLabelHTML());
      this.$qformLabel = document.querySelector(`#${this.qformLabelId}`);
      this.$qformLabelLink = document.querySelector(`#${this.qformLabelLinkId}`);
      if (!this.$submitBox || !this.$qformLabel) {
        clearInterval(interval);
        return;
      }
      this.applyForceLabelStyles();
    }, 5000);
    window.addEventListener("beforeunload", () => clearInterval(interval));
    //останавливаем интервал после отправки формы
    const $formRoot = document.querySelector(`div[data-formid=${this.formId}]`);
    $formRoot.addEventListener(`qform_${this.formId}_send`, () => {
      clearInterval(interval);
    });
  }
  setHoverClass(data) {
    let styleHover = {
      0: "shadow",
      1: "arrow",
      2: "",
      3: "opacity"
    };
    if (!this.$submitBox) {
      this.$submitBox = this.$root.$el.querySelector(`#${this.submitBoxId}`);
    }
    if (data && typeof data.formStyleSubmitButton !== "undefined") {
      if (data && typeof data.formStyleSubmitButton.hoverStyle !== "undefined") {
        if (data.formStyleSubmitButton.hoverStyle !== 2) {
          this.$submitBox.classList.add(`qform-hover-${styleHover[data.formStyleSubmitButton.hoverStyle]}`);
        }
      }
    }
  }
}